module.exports = __webpack_public_path__ + "static/mstile-144x144-4beebfe200fb443c0461803c07a6d2b2.png";